import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Description, Icon, IconTypesKeys } from "@evergis/ui";
import { ServiceListItemDc } from "@evergis/api";

import { castResolutionToScale, scaleIsDefault } from "../../../../../evergis/core/scale";
import { useDefaultScaleRange } from "../../../../../hooks/style/useDefaultScaleRange";
import { FilterCondition } from "../../../../../evergis/core/condition/FilterCondition";

export const AdditionalLayerInfo: FC<{ layer: ServiceListItemDc }> = ({ layer }) => {
  const { t } = useTranslation("catalog");
  const defaultScaleRange = useDefaultScaleRange();

  const { type, condition, geometryType, minResolution, maxResolution } = layer;
  const filterCondition = new FilterCondition(condition);
  const { conditions: parsedConditions } = filterCondition;
  const parsingError = filterCondition.isParsingError();
  const scale = castResolutionToScale({ minResolution, maxResolution }, defaultScaleRange);

  return (
    <Description>
      {!scaleIsDefault({ scale }, defaultScaleRange) && (
        <span>
          <Icon kind="minimize" title={`${t("scaleRange")}: ${scale[0]} - ${scale[1]}`} />
        </span>
      )}
      {condition && (
        <span>
          <Icon kind="filter" title={!parsingError ? `${t("filterConditions")}: ${parsedConditions.length}` : ""} />
        </span>
      )}
      <span>
        <Icon
          style={{ marginRight: 0 }}
          kind={type === "PostgresTileLayerService" ? "geom_raster" : (`geom_${geometryType}` as IconTypesKeys)}
        />
      </span>
    </Description>
  );
};
